import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

export default function AddTagOption({ data, innerProps, innerRef, label }) {
  return (
    <div ref={innerRef} {...innerProps} className="entity" name="add-tag" onClick={data.onClick}>
      <FontAwesomeIcon className="type-icon" icon={faPlus} pull="left" size="lg" />
      <strong>{label}</strong>
    </div>
  );
}

AddTagOption.propTypes = {
  data: PropTypes.shape({
    onClick: PropTypes.func.isRequired
  }).isRequired,
  innerProps: PropTypes.object,
  innerRef: PropTypes.object,
  label: PropTypes.string.isRequired
};
